// extracted by mini-css-extract-plugin
export var closeButton = "_gl-1";
export var closeX = "_gl-3";
export var container = "_gl-0";
export var image = "_gl-2";